module.exports = __webpack_public_path__ + "img/15.a82b8c83.jpg";